import { ComponentList } from '../../components/core/component-list.js';
import { EntityMixin } from '../../components/core/entity-mixin.js';
import { JSONUtils } from '../../utility/json-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import { isSameData } from '../dto/data-model-utils.js';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../dto/data-model.js';

export class BrandProfile extends EntityMixin(DataModel) {
  static readonly TYPE_ID: string = 'ec2f75aaf7844b9480db0590d1ca3914';

  private constructor(
    public readonly uniqueId: string,
    public readonly webRoute: string | null,
    public readonly components: ComponentList,
  ) {
    super();
  }

  get $typeId(): string {
    return BrandProfile.TYPE_ID;
  }

  static create(args: {
    uniqueId: string,
    webRoute: string | null,
    components: ComponentList,
  }): BrandProfile {
    return new BrandProfile(
        args.uniqueId,
        args.webRoute,
        args.components,
    );
  }

  static fromMap(
      context: SerializationContext,
      map: SerializedData,
  ): BrandProfile {
    return BrandProfile.create({
      uniqueId: MapUtils.getString(map, 'uniqueId'),
      webRoute: MapUtils.getStringOrNull(map, 'webRoute'),
      components: ComponentList.deserialize(
          context, MapUtils.getList<SerializedData>(map, 'components', (data) => JSONUtils.decodeRecord(data)),
      ),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      uniqueId: this.uniqueId,
      webRoute: this.webRoute,
      components: this.components.serialize(context),
    };
  }

  clone(): this {
    return BrandProfile.create({
      uniqueId: this.uniqueId,
      webRoute: this.webRoute,
      components: this.components.clone(),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
        other.webRoute === this.webRoute &&
        isSameData(other.components, this.components);
  }
}

export class BrandProfileBuilder extends DataModelBuilder<BrandProfile> {
  build(context: SerializationContext, map: SerializedData): BrandProfile {
    return BrandProfile.fromMap(context, map);
  }
}
